import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { useDeviceType } from "../../../../components/customHooks/useDeviceType";
import { SocialSharePopup } from "../../Atoms/SocialSharePopup";
import { ShareIcon } from "../../Svgs/share-icon";
import { getTextColor } from "../../../utils/utils";
import { getCategoryAndSubCategory, getTemplateName } from "../../../../ga-utils";

import "./social-share-template.m.css";

function getActionIcon(open, color, shareText, isMobile) {
  return (
    <div
      styleName="share-text"
      style={{
        gap: shareText && isMobile ? "var(--spacing-base)" : "0px",
      }}
    >
      <ShareIcon color={color} />
      <div styleName="mobile">{shareText && isMobile && "Share"}</div>
    </div>
  );
}

export const SocialShareTemplate = (props) => {
  const {
    fbUrl = "",
    twitterUrl = "",
    linkedinUrl = "",
    whatsappUrl = "",
    mailtoUrl = "",
    popupText = "",
    vertical = false,
    theme,
    shareText = false,
    iconType = "plain-color-svg",
    open = false,
    fullUrl = "",
    buttonLabel = "",
    onShareClick,
    story = {},
    qtConfig = {},
    eventName = "dl_story_interactions",
    isSummaryCard = false,
  } = props;
  if (!fbUrl && !twitterUrl && !linkedinUrl && !whatsappUrl) return null;
  const iconShade = getTextColor(theme);
  const iconColor = iconShade === "dark" && story["story-template"] !== "video" ? "#000000" : "#ffffff";
  const [isOpen, setIsOpen] = useState(open);
  const verticalShare = vertical ? "vertical" : "horizontal";
  const isMobile = useDeviceType() !== "desktop";
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], {}));
  const config = useSelector((state) => get(state, ["qt", "config"], {}));
  useEffect(() => {
    const floatBTN = document.getElementById("entity-list-floating-btn");
    if (isOpen && isMobile) {
      document.body.classList.add("no-scroll-forShare");
      document.body.classList.remove("scroll-forShare");
      if (floatBTN) {
        floatBTN.style.display = "none";
      }
    } else {
      document.body.classList.add("scroll-forShare");
      document.body.classList.remove("no-scroll-forShare");
      if (floatBTN) {
        floatBTN.style.display = "flex";
      }
    }
    return () => {
      document.body.classList.remove("scroll-forShare");
      document.body.classList.remove("no-scroll-forShare");
      if (floatBTN) {
        floatBTN.style.display = "flex";
      }
    };
  }, [isOpen]);

  const shareIcon = () => {
    return (
      <div className="icon" styleName="icon" key="horizontal-0">
        <div className="icon-with-text" styleName="icon-with-text">
          {buttonLabel === "Share" ? (<i styleName="summaryicon"></i>) : (
            <>{getActionIcon(isOpen, iconColor, shareText, isMobile)}</>
          )}
          {buttonLabel && (
            <span styleName="button-label" className="button-label">
              {buttonLabel}
            </span>
          )}
        </div>
      </div>
    );
  };

  const trackShareClick = () => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const { category, subCategory, contentId } = getCategoryAndSubCategory(window.location, pageType, config, story);
      window.dataLayer.push({
        event: "dl_story_interactions",
        event_action: isSummaryCard ? "short_news_button_click" : "share_click",
        link_text: "share",
        category,
        sub_category: subCategory,
        content_id: contentId,
        template_name: getTemplateName(story?.["story-template"] || pageType),
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const clickHandler = async () => {
    const isWebShareSupported = typeof navigator !== "undefined" && !!navigator.share && isMobile;

    if (isWebShareSupported) {
      try {
        const shareData = {
          title: story?.headline || document.title,
          text: `${story?.headline || document.title}\n\n${fullUrl || window.location.href}`,
        };
        await navigator.share(shareData);
        // Track share via native share API
        onShareClick ? onShareClick() : trackShareClick();
      } catch (err) {
        if (err.name === "AbortError" || err.message === "Share cancelled") {
          console.info("Native share cancelled by user.");
        } else {
          console.error("Native share failed:", err);
        }
      }
    } else {
      if (!isOpen) {
        // Track share click when opening the popup
        onShareClick ? onShareClick() : trackShareClick();
      }
      setIsOpen(!isOpen);
    }
  };

  const popUpWrapper = () => {
    return (
      <div styleName="tablet-view">
        <div styleName={`wrapper ${isOpen ? "open" : ""}`}>{shareIcon()}</div>
        {isOpen && (
          <div styleName="overlay" onClick={clickHandler}>
            <div className="arr--popup" styleName={`popup-wrapper ${isOpen ? "popup-open" : ""}`}>
              <SocialSharePopup
                fbUrl={fbUrl}
                twitterUrl={twitterUrl}
                linkedinUrl={linkedinUrl}
                whatsappUrl={whatsappUrl}
                mailtoUrl={mailtoUrl}
                iconType={iconType}
                theme={theme}
                fullUrl={fullUrl}
                popupText={popupText}
                onShareClick={onShareClick}
                story={story}
                config={config}
                pageType={pageType}
                isSummaryCard={isSummaryCard}
                closePopup={() => {
                  setIsOpen(false);
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  };
  const openClass = isOpen ? "open" : "";
  return (
    <div data-test-id={verticalShare} className="arr--share" onClick={clickHandler}>
      <div styleName="desktop-view">
        {shareIcon()}
        {isOpen && <div styleName="desktop-overlay" onClick={() => setIsOpen(false)} />}
        <div className={`desktop-share-wrapper ${openClass}`} styleName={`wrapper ${openClass}`}>
          {isOpen && (
            <SocialSharePopup
              fbUrl={fbUrl}
              twitterUrl={twitterUrl}
              linkedinUrl={linkedinUrl}
              whatsappUrl={whatsappUrl}
              mailtoUrl={mailtoUrl}
              iconType={iconType}
              theme={theme}
              popupText={popupText}
              fullUrl={fullUrl}
              onShareClick={onShareClick}
              story={story}
              config={config}
              pageType={pageType}
              isSummaryCard={isSummaryCard}
              isDesktop
              closePopup={() => {
                setIsOpen(false);
              }}
            />
          )}
        </div>
      </div>
      {popUpWrapper()}
    </div>
  );
};

SocialShareTemplate.propTypes = {
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  linkedinUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  mailtoUrl: PropTypes.string,
  vertical: PropTypes.bool,
  popupText: PropTypes.string,
  theme: PropTypes.string,
  iconType: PropTypes.string,
  open: PropTypes.bool,
  shareText: PropTypes.bool,
  fullUrl: PropTypes.string,
  buttonLabel: PropTypes.string,
  onShareClick: PropTypes.func,
  story: PropTypes.object,
  qtConfig: PropTypes.object,
  isSummaryCard: PropTypes.bool,
};
